/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLocation } from 'react-router-dom';
import { getAnonymousID } from 'redline-client-sdk';

interface ITrackingEventPayload {
  eventName: string;
  payload?: any;
}

export const useGoogleAnalytics = () => {
  const location = useLocation();

  function trackGA({ eventName, payload }: ITrackingEventPayload): void {
    try {
      const isDebtSimulated = eventName === 'user_authenticated_with_debt';
      const isNegativeDebtSimulated = eventName === 'user_authenticated_with_negative_debt';
      const shouldDispatchBothContainers = isDebtSimulated || isNegativeDebtSimulated;

      // @ts-ignore
      if (window?.isNativeApp) {
        // Names should contain 1 to 40 alphanumeric characters or underscores.
        const formattedEventName = `app_${
          eventName
            .replace(/[^a-zA-Z0-9_]/g, '_') // Replace non-alphanumeric/underscore with _
            .replace(/_{2,}/g, '_') // Replace multiple underscores with single
            .replace(/^_+|_+$/g, '') // Trim leading/trailing underscores
        }`;
        if (formattedEventName.length > 40) {
          console.error(`${formattedEventName} exceeds 40 characters, won't be sent to Firebase Analytics`);
        } else {
          // @ts-ignore
          window?.bridge?.analyticsFirebaseLogEvent(formattedEventName, payload || {});
        }
        if (!shouldDispatchBothContainers) return;
      }

      if (!window?.gtag) {
        return;
      }

      const anonymousId = getAnonymousID();
      const url = location.pathname;

      const safePayload = payload ? { ...payload, anonymousId, url } : { anonymousId, url };

      return window.gtag('event', eventName, safePayload);
    } catch (error) {
      console.error('Error tracking GA event:', error);
    }
  }

  return { trackGA };
};
